import React, { useState, useEffect } from 'react';
import { useAuth } from './hooks/useAuth';
import LoadingScreen from './components/LoadingScreen';
import MainLayout from './components/MainLayout';
import InitialSetupComponent from './Layouts/InitialSetupComponent';
import DatabaseSetupComponent from './Layouts/DatabaseSetup';
import Dashboard from './Layouts/Dashboard/Dashboard';
import LoginScreen from './Layouts/LoginScreen';
import SetupClassesAndSections from './Layouts/SetupClassesAndSections';
import SetupTimetable from './Layouts/TimetableSetup/SetupTimetable';
import SubjectsSetup from './Layouts/SubjectsSetup/SubjectsSetup';
import SchoolLocationSetup from './Layouts/SchoolLocationSetup/SchoolLocationSetup';
import { useDefaultDataStore } from './stateManagers/store/useDefaultDataStore';
import Settings from './Layouts/Settings/settings';
import AppVersionsManager from './Layouts/AppVersionsManager';
import StudentBulkUpload from './Layouts/StudentCsvSetup/StudentBulkUpload';
import TeachersBulkUpload from './Layouts/TeachersCsvSetup/TeachersBulkUpload';
import ExamTypesSetup from './Layouts/ExamTypesSetup/ExamTypesSetup';
import ProfilePictureOptimizer from './Layouts/ProfilePictureOptimizer/ProfilePictureOptimizer';
import FeeSetup from './Layouts/FeesSetup/FeeSetup';
import SchoolLetterHeader from './Layouts/LetterHeaderSetup/SchoolLetterHeader';
import SessionManagement from './Layouts/SessionManagement/SessionManagement';

const App: React.FC = () => {
  const { isAuthenticated, user, loading, logout } = useAuth();
  const [activeComponent, setActiveComponent] = useState('dashboard');

  const { fetchDefaultData } = useDefaultDataStore();

  useEffect(() => {
    if (isAuthenticated) {
      console.log('✅ Auth confirmed — loading default app data (e.g., active school)...');
      fetchDefaultData();
    }
  }, [isAuthenticated, fetchDefaultData]);

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to logout?')) {
      await logout();
    }
  };

  const renderContent = () => {
    switch (activeComponent) {
      case 'dashboard':
        return <Dashboard  />;
      case 'database-setup':
        return <DatabaseSetupComponent />;
      case 'Settings':
        return <Settings />;
      case 'SchoolLocationSetup':
        return <SchoolLocationSetup />;
        
      case 'SessionManagement':
  return <SessionManagement />;
case 'initial-setup':
  return <InitialSetupComponent />;

      case 'SetupClassesAndSections':
        return <SetupClassesAndSections />;
      case 'SetupTimetable':
        return <SetupTimetable />;
      case 'SubjectsSetup':
        return <SubjectsSetup />;
      case 'Students-Csv':
        return <StudentBulkUpload />;
      case 'Teachers-Csv':
        return <TeachersBulkUpload />;
      case 'SchoolLetterHeader':
        return <SchoolLetterHeader />;
      case 'ExamsTypeSetup':
        return <ExamTypesSetup />;
      case 'ProfilePictureOptimizer':
        return <ProfilePictureOptimizer />;
      case 'AppSetup':
        return <AppVersionsManager />;
      case 'FeeSetup':
        return <FeeSetup />;
      default:
        return (
          <div>
            <h2>Welcome!</h2>
            <p>Select a menu item from the sidebar...</p>
          </div>
        );
    }
  };

  if (loading) return <LoadingScreen />;

  if (!isAuthenticated) return <LoginScreen />;

  return (
    <MainLayout
      activeComponent={activeComponent}
      setActiveComponent={setActiveComponent}
      onLogout={handleLogout}
    >
      {renderContent()}
    </MainLayout>
  );
};

export default App;